/**
 * Index of the earliest time-machine entry whose step failed without being rescued, or -1 when
 * none did.
 *
 * The log viewer's error jump used to open the last action. That is the failing action only in
 * a sequential run: a parallel loop lets its in-flight items finish after a failure, so the last
 * action is a later, successful item and the failure sits earlier in the timeline.
 *
 * A failure handled by the step's Flow Control (`onFailure` continue / next / break) keeps
 * `success: false` on its response but did not stop the run; `handleFlowControl` marks it with
 * `meta.flowControl.onFailureAction`, so it is skipped in favor of the failure that did.
 */
const isUnhandledFailure = (entry) => {
  const response = entry?.step?.response;
  return response?.success === false && !response?.meta?.flowControl?.onFailureAction;
};

const findFirstFailedTimeMachineIndex = (timeMachine) => (Array.isArray(timeMachine) ? timeMachine.findIndex(isUnhandledFailure) : -1);

export default findFirstFailedTimeMachineIndex;
